import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCircleCrossOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M2.127 12c0-5.453 4.42-9.873 9.873-9.873 5.453 0 9.873 4.42 9.873 9.873 0 5.453-4.42 9.873-9.873 9.873-5.453 0-9.873-4.42-9.873-9.873ZM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-1.678 8.818a1.063 1.063 0 0 0-1.504 1.504L10.496 12l-1.678 1.678a1.063 1.063 0 1 0 1.504 1.504L12 13.504l1.678 1.678a1.063 1.063 0 1 0 1.504-1.504L13.504 12l1.678-1.678a1.063 1.063 0 1 0-1.504-1.504L12 10.496l-1.678-1.678Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCircleCrossOutline);
export default ForwardRef;
